import React, { useState, useEffect, createContext } from "react";
import axios from "axios";
export const ContentContext = createContext();
export const ContentProvider = (props) => {
  const [movies, setMovies] = useState([]);
  const [games, setGames] = useState([]);
  const [fetch, setFetch] = useState(true);

  useEffect(() => {
    const fetchMovies = async () => {
      let res = await axios.get(
        `https://backendexample.sanbersy.com/api/data-movie`
      );

      setMovies(
        res.data.map((value, index) => {
          return {
            index: index + 1,
            id: value.id,
            title: value.title,
            description: value.description,
            year: value.year,
            duration: value.duration,
            genre: value.genre,
            rating: value.rating,
            review: value.review,
            image: value.image_url,
          };
        })
      );
    };
    const fetchGames = async () => {
      let res = await axios.get(
        `https://backendexample.sanbersy.com/api/data-game`
      );

      setGames(
        res.data.map((value, index) => {
          return {
            index: index + 1,
            id: value.id,
            name: value.name,
            genre: value.genre,
            release: value.release,
            platform: value.platform,
            singlePlayer: value.singlePlayer,
            multiPlayer: value.multiPlayer,
            image: value.image_url,
          };
        })
      );
    };
    fetchMovies();
    fetchGames();
  }, [fetch]);

  return (
    <ContentContext.Provider
      value={{
        games,
        setGames,
        movies,
        setMovies,
        fetch,
        setFetch,
      }}
    >
      {props.children}
    </ContentContext.Provider>
  );
};
